import { type Theme } from '@mui/material';

export const sxItemButton = (selected: boolean, theme: Theme) => ({
  borderRadius: 2,
  p: 1,
  bgcolor: selected ? theme.palette.action.selected : 'transparent',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
});

export const sxIcon = (theme: Theme) => ({
  color: theme.palette.primary.main,
  position: 'absolute',
  top: '7px',
  left: '7px',
});

export const sxLocationBox = { flex: '0 0 auto', maxWidth: '40%', ml: 1, display: 'flex', alignItems: 'center' };
